import { patchRequest } from 'utils/api/apiRequest'

export type DataCharity = {
  charity: number
}

export const patchShoppingCartCharity = (data: DataCharity) => patchRequest(`/redemption-site/charity`, data)
